// extracted by mini-css-extract-plugin
module.exports = {"row":"SpList_row__2xB6V","nosp":"SpList_nosp__luwo7"};